module.exports = __webpack_public_path__ + "static/media/logobrown.e1a9a00e.png";